(function () {
    'use strict';
    angular.module('app').config(transitWarrantyUrlConfig);
    transitWarrantyUrlConfig.$inject = ['$routeProvider', '$locationProvider'];

    function transitWarrantyUrlConfig($routeProvider, $locationProvider) {
        $routeProvider
            .when('/transit-warranty/claims', {
                templateUrl: '/templates/pages/transit-warranty/transit-warranty-claims.html',
                controller: 'TransitWarrantyClaimsController',
                controllerAs: 'vm',
                params: {
                    icon: 'fa fa-file',
                    parent: 'transit-warranty',
                    htmlTitle: 'Transit Warranty Claims',
                    pageTitle: 'Transit Warranty Claims'
                }
            })
            .when('/transit-warranty/reports', {
                templateUrl: '/templates/pages/transit-warranty/transit-warranty-reports.html',
                controller: 'TransitWarrantyReportsController',
                controllerAs: 'vm',
                params: {
                    icon: 'fa fa-book',
                    parent: 'transit-warranty',
                    htmlTitle: 'Transit Warranty Reports',
                    pageTitle: 'Transit Warranty Reports'
                }
            })
            .when('/transit-warranty/providers', {
                templateUrl: '/templates/pages/transit-warranty/transit-warranty-providers.html',
                controller: 'TransitWarrantyProvidersController',
                controllerAs: 'vm',
                params: {
                    icon: 'fa fa-book',
                    parent: 'transit-warranty',
                    htmlTitle: 'Transit Warranty Providers',
                    pageTitle: 'Transit Warranty Providers'
                }
            });
        $locationProvider.html5Mode({
            enabled: true,
            requireBase: true
        });
    }
})();


// WEBPACK FOOTER //
// ./js/urls/transit-warranty.js